/*
 * @Description: 自有车线路 store
 * @Author: lijinpeng
 * @Date: 2022-10-20 11:06:33
 * @LastEditTime: 2023-06-26 13:54:52
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { getProjectListByBid } from '@/api/project';
import { postRoutePageList, getRouteListByBid } from '@/api/routeInfo';
import { filterTestCorp } from '@/utils/util';

const storeModuleName = 'routeOwnModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'autocomplete',
      param: 'projectName',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'autocomplete',
      param: 'routeInfoName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'date-picker',
      param: 'createTime',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['createStartTime', 'createEndTime'],
    },
    {
      style: 'input',
      param: 'creatorName',
      value: '',
      valueType: 'string',
      label: '创建人',
      placeholder: '请输入',
      clearable: true,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  isExport: false, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '企业名称',
        prop: 'companyName',
        width: 140,
        fixed: 'left',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-companyName',
      },
      {
        label: '线路名称',
        prop: 'orderName',
        width: 140,
        checked: 1,
        sortable: true,
      },
      {
        label: '装卸货地',
        prop: 'address',
        width: 220,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-address',
      },
      {
        label: '货物信息',
        prop: 'goodsInfo',
        width: 170,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-goodsInfo',
      },
      {
        label: '创建时间',
        prop: 'createTime',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-createTime',
      },
      {
        label: '操作',
        width: 80,
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        params[item.param] = item.value;
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    const { data } = await postRoutePageList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    return data.list;
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getRouteListByBid({
        businessId: context.state.parameters[0].value,
        projectId: context.state.postParams.projectId,
        lineType: 'own',
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
      lineType: 'own',
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        if (state.parameters[1].value) {
          state.parameters[1].value = '';
          state.postParams.projectId = '';
        }
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'routeInfoName':
        state.postParams.routeInfoId = payload.id;
        break;
      default:
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
